export const InviteFriendStyles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: "24px",
  },
  // title: {
  //   display: "flex",
  // },
  // icon: {
  //   marginRight: "16px",
  // },
  // text: {
  //   fontWeight: 500,
  //   fontSize: "22px",
  //   lineHeight: "27px",
  //   color: "#103B66",
  // },
  middle: {
    marginBottom: "24px",
  },
  middlePercDetails: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "22px",
  },
  bottom: {
    display: "flex",
    color: "#21B8F9",
  },
  bottomText: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "20px",
    textDecorationLine: "underline",
    marginRight: "12px",
    cursor: "pointer",
  },
  products: { color: "#00C48C" },
};
